module.exports = __webpack_public_path__ + "img/workforce-explorers.3ca40326.webp";